module.exports = __webpack_public_path__ + "static/media/slider-l4-360.b32e7975.webp";